// extracted by mini-css-extract-plugin
module.exports = {"tagtitle":"TagView_tagtitle__3ztjj","tagsubtitle":"TagView_tagsubtitle__1rIc3","deleteButton":"TagView_deleteButton__TNKC5"};